const language = {
  "ar-u-nu-latn": {
    version: "Version",
    privacy_history: "Previous versions of Xiaomi Privacy Policy",
    history_version: "Previous versions of Privacy Policy",
    title: "Privacy at Xiaomi",
  },
  ar_EG: {
    version: "الإصدار",
    privacy_history: "الإصدارات السابقة من سياسة خصوصية Xiaomi",
    history_version: "الإصدارات السابقة من سياسة الخصوصية",
    title: "خصوصية Xiaomi",
  },
  as_IN: {
    version: "সংস্কৰণ",
    privacy_history: "Xiaomi গোপনীয়তাৰ নীতিৰ পূৰ্বৱৰ্তী সংস্কৰণসমূহ",
    history_version: "গোপনীয়তাৰ নীতিৰ পূৰ্বৱৰ্তী সংস্কৰণসমূহ",
    title: "Xiaomiত গোপনীয়তা",
  },
  az_AZ: {
    version: "Versiya",
    privacy_history: "Xiaomi Gizlilik Siyasətinin əvvəlki versiyaları",
    history_version: "Gizlilik Siyasətinin əvvəlki versiyaları",
    title: "Xiaomi-də Gizlilik",
  },
  be_BY: {
    version: "Версія",
    privacy_history: "Папярэднія версіі Палітыкі канфiдэнцыяльнасцi Xiaomi",
    history_version: "Папярэднія версіі Палітыкі прыватнасці",
    title: "Канфідэнцыяльнасць у Xiaomi",
  },
  bg_BG: {
    version: "Версия",
    privacy_history: "Предишни версии на Правилата за поверителност на Xiaomi",
    history_version: "Предишни версии на Правилата за поверителност",
    title: "Поверителност в Xiaomi",
  },
  bn_BD: {
    version: "ভার্সন",
    privacy_history: "Xiaomi গোপনীয়তা নীতির আগের ভার্সন",
    history_version: "গোপনীয়তা নীতির আগের ভার্সন",
    title: "Xiaomiতে গোপনীয়তা",
  },
  bn_IN: {
    version: "ভার্সন",
    privacy_history: "Xiaomi গোপনীয়তা নীতির আগের ভার্সন",
    history_version: "গোপনীয়তা নীতির আগের ভার্সন",
    title: "Xiaomiতে গোপনীয়তা",
  },
  bo_CN: {
    version: "པར་གཞིའི་ཨང་རྟགས།",
    privacy_history: "ཞའོ་མཱི་གསང་དོན་སྲིད་ཇུས་ཀྱི་ལོ་རྒྱུས་པར་གཞི།",
    history_version: "གསང་དོན་སྲིད་ཇུས་ཀྱི་ལོ་རྒྱུས་པར་གཞི།",
    title: "ཞའོ་མཱི་གསང་དོན།",
  },
  bs_BA: {
    version: "Verzija",
    privacy_history: "Prethodne verzije Xiaomi Odredbi o privatnosti",
    history_version: "Prethodne verzije Odredbi o privatnosti",
    title: "Xiaomi privatnost",
  },
  ca_ES: {
    version: "Versió",
    privacy_history: "Versions anteriors de la Política de privadesa de Xiaomi",
    history_version: "Versions anteriors de la Política de privadesa",
    title: "Privacitat de Xiaomi",
  },
  cs_CZ: {
    version: "Verze",
    privacy_history: "Předchozí verze Zásad ochrany osobních údajů Xiaomi",
    history_version: "Předchozí verze Zásad ochrany osobních údajů",
    title: "Ochrana soukromí ve Xiaomi",
  },
  da_DK: {
    version: "Version",
    privacy_history: "Tidligere versioner af Xiaomis privatlivspolitik",
    history_version: "Tidligere versioner af privatlivspolitik",
    title: "Privatliv hos Xiaomi",
  },
  de_DE: {
    version: "Version",
    privacy_history:
      "Vorherige Versionen der Xiaomi-Datenschutzerklärung ansehen",
    history_version: "Vorherige Versionen der Datenschutzerklärung",
    title: "Datenschutz bei Xiaomi",
  },
  el_GR: {
    version: "Έκδοση",
    privacy_history: "Ποηγούμενες εκδόσεις Πολιτικής Απορρήτου Xiaomi",
    history_version: "Προηγούμενες εκδόσεις Πολιτικής Απορρήτου",
    title: "Το Αππόρητο στην Xiaomi",
  },
  en_AU: {
    version: "Version",
    privacy_history: "Previous versions of Xiaomi Privacy Policy",
    history_version: "Previous versions of Privacy Policy",
    title: "Privacy at Xiaomi",
  },
  en_GB: {
    version: "Version",
    privacy_history: "Previous versions of Xiaomi Privacy Policy",
    history_version: "Previous versions of Privacy Policy",
    title: "Privacy at Xiaomi",
  },
  en_IN: {
    version: "Version",
    privacy_history: "Previous versions of Xiaomi Privacy Policy",
    history_version: "Previous versions of Privacy Policy",
    title: "Privacy at Xiaomi",
  },
  en_US: {
    version: "Version",
    privacy_history: "Previous versions of Xiaomi Privacy Policy",
    history_version: "Previous versions of Privacy Policy",
    title: "Privacy at Xiaomi",
  },
  es_ES: {
    version: "Versión",
    privacy_history:
      "Versiones anteriores de la Política de Privacidad de Xiaomi",
    history_version: "Versiones anteriores de la Política de Privacidad",
    title: "Privacidad en Xiaomi",
  },
  es_US: {
    version: "Versión",
    privacy_history:
      "Versiones anteriores de la Política de Privacidad de Xiaomi",
    history_version: "Versiones anteriores de la Política de Privacidad",
    title: "Privacidad en Xiaomi",
  },
  et_EE: {
    version: "Versioon",
    privacy_history: "Xiaomi privaatsuspoliitika eelmised versioonid",
    history_version: "Privaatsuspoliitika eelmised versioonid",
    title: "Xiaomi privaatsus",
  },
  eu_ES: {
    version: "Bertsioa",
    privacy_history: "Xiaomiren Pribatutasun Politikaren aurreko bertsioak",
    history_version: "Pribatutasun Politikaren aurreko bertsioak",
    title: "Pribatutasuna Xiaomi-n",
  },
  "fa-u-nu-latn": {
    version: "Version",
    privacy_history: "Previous versions of Xiaomi Privacy Policy",
    history_version: "Previous versions of Privacy Policy",
    title: "حریم خصوصی در Xiaomi",
  },
  fa_IR: {
    version: "نسخه",
    privacy_history: "نسخه‌های قبلی سیاست حفظ حریم خصوصی Xiaomi",
    history_version: "نسخه‌های قبلی سیاست حفظ حریم خصوصی",
    title: "حریم خصوصی در Xiaomi",
  },
  fi_FI: {
    version: "Versio",
    privacy_history: "Xiaomi-tietosuojakäytännön aiemmat versiot",
    history_version: "Tietosuojakäytännön aiemmat versiot",
    title: "Yksityisyys Xiaomissa",
  },
  fr_FR: {
    version: "Version",
    privacy_history:
      "Versions précédentes de la Politique de Confidentialité de Xiaomi",
    history_version: "Versions précédentes de la Politique de Confidentialité",
    title: "Confidentialité chez Xiaomi",
  },
  gl_ES: {
    version: "Versión",
    privacy_history: "Versións previas da Política de privacidade de Xiaomi",
    history_version: "Versións previas da Política de privacidade",
    title: "Privacidade en Xiaomi",
  },
  gu_IN: {
    version: "વર્ઝન",
    privacy_history: "Xiaomi પ્રાઇવસી પોલિસીના પહેલાનાં વર્ઝન",
    history_version: "પ્રાઇવસી પોલિસીના પહેલાનાં વર્ઝન",
    title: "Xiaomiમાં ગોપનીયતા",
  },
  ha_NG: {
    version: "Siga",
    privacy_history: "Sigogin Sharuddan Bayanai na Xiaomi dasuka gabata",
    history_version: "Sigogin Sharuddan Bayanai dasuka gabata",
    title: "Sharuddan Bayanai",
  },
  hi_IN: {
    version: "संस्करण",
    privacy_history: "Xiaomi गोपनीयता नीति के पिछले संस्करण",
    history_version: "गोपनीयता नीति के पिछले संस्करण",
    title: "Xiaomi में गोपनीयता",
  },
  hr_HR: {
    version: "Verzija",
    privacy_history: "Prethodne verzije Xiaomi Pravila o privatnosti",
    history_version: "Prethodne verzije Pravila o privatnosti",
    title: "Privatnost kod Xiaomi-ja",
  },
  hu_HU: {
    version: "Verzió",
    privacy_history: "A Xiaomi Adatvédelmi irányelveinek korábbi verziói",
    history_version: "Az Adatvédelmi irányelvek korábbi verziói",
    title: "A Xiaomi adatvédelme",
  },
  hy_AM: {
    version: "Տարբերակ",
    privacy_history: "Xiaomi Գաղտնիության Քաղաքականության նախորդ տարբերակները",
    history_version: "Գաղտնիության Քաղաքականության նախորդ տարբերակները",
    title: "Գաղտնիությունը Xiaomi-ում",
  },
  in_ID: {
    version: "Versi",
    privacy_history: "Versi Kebijakan Privasi sebelumnya",
    history_version: "Versi Kebijakan Privasi sebelumnya",
    title: "Privasi di Xiaomi",
  },
  id_ID: {
    version: "Versi",
    privacy_history: "Versi Kebijakan Privasi sebelumnya",
    history_version: "Versi Kebijakan Privasi sebelumnya",
    title: "Privasi di Xiaomi",
  },
  it_IT: {
    version: "Versione",
    privacy_history:
      "Versioni precedenti dell'Informativa sulla privacy di Xiaomi",
    history_version: "Versioni precedenti dell'Informativa sulla privacy",
    title: "Privacy in Xiaomi",
  },
  iw_IL: {
    version: "גרסה",
    privacy_history: "גרסאות קודמות של מדיניות הפרטיות של Xiaomi",
    history_version: "גרסאות קודמות של מדיניות הפרטיות",
    title: "פרטיות ב-Xiaomi",
  },
  ja_JP: {
    version: "バージョン",
    privacy_history: "旧バージョンのXiaomi プライバシーポリシー",
    history_version: "旧バージョンのプライバシーポリシー",
    title: "Xiaomiにおけるプライバシー",
  },
  ka_GE: {
    version: "ვერსია",
    privacy_history: "Xiaomi-ს კონფიდენციალურობის პოლიტიკის წინა ვერსიები",
    history_version: "კონფიდენციალურობის პოლიტიკის წინა ვერსიები",
    title: "კონფიდენციალურობა Xiaomi-ზე",
  },
  kk_KZ: {
    version: "Нұсқа",
    privacy_history: "Xiaomi Құпиялылық Саясатының алдыңғы нұсқалары",
    history_version: "Құпиялылық Саясатының алдыңғы нұсқалары",
    title: "Xiaomi Құпиялылығы",
  },
  km_KH: {
    version: "សំណៅ​កំណែ",
    privacy_history:
      "សំណៅកំណែគោលការណ៍ការពារឯកជនភាព ឬសិទ្ធិឯកជនពីមុនរបស់ក្រុមហ៊ុន Xiaomi",
    history_version: "កំណែមុននៃគោលការណ៍​​ឯកជនភាព",
    title: "ឯកជនភាពនៅក្រុមហ៊ុន Xiaomi",
  },
  kn_IN: {
    version: "ಆವೃತ್ತಿ",
    privacy_history: "Xiaomi ಗೌಪ್ಯತೆ ನೀತಿಯ ಹಿಂದಿನ ಆವೃತ್ತಿಗಳು",
    history_version: "ಗೌಪ್ಯತೆ ನೀತಿಯ ಹಿಂದಿನ ಆವೃತ್ತಿಗಳು",
    title: "Xiaomi ಯಲ್ಲಿ ಗೌಪ್ಯತೆ",
  },
  ko_KR: {
    version: "버전",
    privacy_history: "Xiaomi 개인 정보 보호 정책의 이전 버전",
    history_version: "개인 정보 보호 정책의 이전 버전",
    title: "Xiaomi 개인 정보 보호",
  },
  lo_LA: {
    version: "​ເວີ​ຊັ່ນ",
    privacy_history: "ເວີຊັ່ນທີ່ຜ່ານມາຂອງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວຂອງ Xiaomi",
    history_version: "ເວີຊັ່ນທີ່ຜ່ານມາຂອງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",
    title: "ຄວາມເປັນສ່ວນຕົວທີ່ Xiaomi",
  },
  lt_LT: {
    version: "Versija",
    privacy_history: "Ankstesnės „Xiaomi“ privatumo politikos versijos",
    history_version: "Ankstesnės privatumo politikos versijos",
    title: "Privatumas „Xiaomi“ įmonėje",
  },
  lv_LV: {
    version: "Versija",
    privacy_history:
      "Iepriekšējās Xiaomi Konfidencialitātes politikas versijas",
    history_version: "Iepriekšējās Konfidencialitātes politikas versijas",
    title: "Xiaomi konfidencialitāte",
  },
  mk_MK: {
    version: "Верзија",
    privacy_history: "Претходни верзии на Политиката за приватност на Xiaomi",
    history_version: "Претходни верзии на Политиката за приватност на",
    title: "Приватност во Xiaomi",
  },
  ml_IN: {
    version: "പതിപ്പ്",
    privacy_history: "Xiaomi സ്വകാര്യതാ നയത്തിന്റെ മുൻ പതിപ്പുകൾ",
    history_version: "സ്വകാര്യതാ നയത്തിന്റെ മുൻ പതിപ്പുകൾ",
    title: "Xiaomi-ലെ സ്വകാര്യത",
  },
  mr_IN: {
    version: "आवृत्ती",
    privacy_history: "Xiaomi गोपनीयता धोरणाच्या आधीच्या आवृत्ती",
    history_version: "गोपनीयता धोरणाच्या आधीच्या आवृत्ती",
    title: "Xiaomi मधील गोपनीयता",
  },
  ms_MY: {
    version: "Versi",
    privacy_history: "Versi Dasar Privasi Xiaomi yang terdahulu",
    history_version: "Versi Dasar Privasi yang terdahulu",
    title: "Privasi di Xiaomi",
  },
  mt_MT: {
    version: "Verżjoni",
    privacy_history:
      "Il-verżjonijiet il-qodma tal-Politika tal-Privatezza ta' Xiaomi",
    history_version: "Verżjonijiet qodma tal-Politika tal-Privatezza",
    title: "Il-Privatezza ma\\' Xiaomi",
  },
  my_MM: {
    version: "ဗားရှင်း",
    privacy_history: "Xiaomi ပုဂ္ဂိုလ်ရေးလုံခြုံမှု မူဝါဒ ယခင်ဗားရှင်းများ",
    history_version: "ပုဂ္ဂိုလ်ရေးလုံခြုံမှု မူဝါဒ ယခင်ဗားရှင်းများ",
    title: "Xiaomi ရှိ ပုဂ္ဂိုလ်ရေးလုံခြုံမှု",
  },
  nb_NO: {
    version: "Versjon",
    privacy_history: "Tidligere versjoner av Xiaomis personvernerklæring",
    history_version: "Tidligere versjoner av personvernerklæringen",
    title: "Personvern hos Xiaomi",
  },
  ne_IN: {
    version: "संस्करण",
    privacy_history: "Xiaomi गोपनीयता नीतिको अघिल्लो संस्करणहरू",
    history_version: "गोपनीयता नीतिको अघिल्लो संस्करणहरू",
    title: "Xiaomi मा गोपनीयता",
  },
  ne_NP: {
    version: "संस्करण",
    privacy_history: "Xiaomi गोपनीयता नीतिको अघिल्लो संस्करणहरू",
    history_version: "गोपनीयता नीतिको अघिल्लो संस्करणहरू",
    title: "Xiaomi मा गोपनीयता",
  },
  nl_NL: {
    version: "Versie",
    privacy_history: "Eerdere versies van Xiaomi Privacybeleid",
    history_version: "Eerdere versies van het Privacybeleid",
    title: "Privacy bij Xiaomi",
  },
  or_IN: {
    version: "ସଂସ୍କରଣ",
    privacy_history: "Xiaomi ଗୋପନୀୟତା ନୀତିର ପୂର୍ବ ସଂସ୍କରଣଗୁଡ଼ିକ",
    history_version: "ଗୋପନୀୟତା ନୀତିର ପୂର୍ବ ସଂସ୍କରଣଗୁଡ଼ିକ",
    title: "Xiaomiରେ ଗୋପନୀୟତା",
  },
  pa_IN: {
    version: "ਵਰਜਨ",
    privacy_history: "Xiaomi ਪਰਦੇਦਾਰੀ ਨੀਤੀ ਦਾ ਪਿਛਲਾ ਵਰਜਨ",
    history_version: "ਪਰਦੇਦਾਰੀ ਨੀਤੀ ਦਾ ਪਿਛਲਾ ਵਰਜਨ",
    title: "Xiaomi ਵਿੱਚ ਪਰਦੇਦਾਰੀ",
  },
  pl_PL: {
    version: "Wersja",
    privacy_history: "Poprzednie wersje Polityki Prywatności Xiaomi",
    history_version: "Poprzednie wersje Polityki Prywatności",
    title: "Prywatność w Xiaomi",
  },
  pt_BR: {
    version: "Versão",
    privacy_history: "Versões anteriores da Política de Privacidade da Xiaomi",
    history_version: "Versões anteriores da Política de Privacidade",
    title: "Privacidade na Xiaomi",
  },
  pt_PT: {
    version: "Versão",
    privacy_history: "Versões anteriores da Política de Privacidade da Xiaomi",
    history_version: "Versões anteriores da Política de Privacidade",
    title: "Privacidade na Xiaomi",
  },
  ro_RO: {
    version: "Versiune",
    privacy_history:
      "Versiunile anterioare ale Politicii de confidențialitate Xiaomi",
    history_version: "Versiunile anterioare ale Politicii de confidențialitate",
    title: "Confidențialitate la Xiaomi",
  },
  ru_RU: {
    version: "Версия",
    privacy_history: "Предыдущие версии Политики конфиденциальности Xiaomi",
    history_version: "Предыдущие версии Политики конфиденциальности",
    title: "Конфиденциальность в Xiaomi",
  },
  sk_SK: {
    version: "Verzia",
    privacy_history: "Predchádzajúce verzie Zásad ochrany osobných údajov",
    history_version: "Predchádzajúce verzie Zásad ochrany osobných údajov",
    title: "Súkromie v spoločnosti Xiaomi",
  },
  sl_SI: {
    version: "Različica",
    privacy_history: "Prejšnje različice Xiaomi Pravilnika o zasebnosti",
    history_version: "Prejšnje različice Pravilnika o zasebnosti",
    title: "Zasebnost v Xiaomi",
  },
  sq_AL: {
    version: "Versioni",
    privacy_history: "Versionet e mëparshme të Politikës së Privatësisë Xiaomi",
    history_version: "Versionet e mëparshme të Politikës së Privatësisë",
    title: "Privatësi në Xiaomi",
  },
  sr_RS: {
    version: "Верзија",
    privacy_history: "Претходне верзије Xiaomi Правила о приватности",
    history_version: "Претходне верзије Правила о приватности",
    title: "Xiaomi приватност",
  },
  sv_SE: {
    version: "Version",
    privacy_history: "Tidigare versioner av Xiaomis Integritetspolicy",
    history_version: "Tidigare versioner av Integritetspolicy",
    title: "Integritet hos Xiaomi",
  },
  ta_IN: {
    version: "பதிப்பு",
    privacy_history: "Xiaomi தனியுரிமைக் கொள்கையின் முந்தைய பதிப்புகள்",
    history_version: "தனியுரிமைக் கொள்கையின் முந்தைய பதிப்புகள்",
    title: "Xiaomi -இல் தனியுரிமை",
  },
  te_IN: {
    version: "వెర్షన్",
    privacy_history: "Xiaomi గోప్యతా విధానం యొక్క మునుపటి వెర్షన్",
    history_version: "గోప్యతా విధానం యొక్క మునుపటి వెర్షన్",
    title: "Xiaomi వద్ద గోప్యత",
  },
  th_TH: {
    version: "เวอร์ชั่น ",
    privacy_history: "นโยบายความเป็นส่วนตัว Xiaomi เวอร์ชันก่อนหน้า",
    history_version: "นโยบายความเป็นส่วนตัวเวอร์ชันก่อนหน้า",
    title: "ความเป็นส่วนตัวที่ Xiaomi",
  },
  tr_TR: {
    version: "Sürüm",
    privacy_history: "Xiaomi Gizlilik Politikası'nın önceki sürümleri",
    history_version: "Gizlilik Politikası'nın önceki sürümleri",
    title: "Xiaomi\\'de Gizlilik",
  },
  ug_CN: {
    version: "نەشر نومۇرى",
    privacy_history: "شياۋمى شەخسىي مەخپىيەتلىك سىياسىتى بۇرۇنقى نەشرى",
    history_version: "شەخسىي مەخپىيەتلىك سىياسىتى بۇرۇنقى نەشرى",
    title: "شياۋمى شەخسىي مەخپىيەتلىكى",
  },
  uk_UA: {
    version: "Версія",
    privacy_history: "Попередні версії Політики конфіденційності Xiaomi",
    history_version: "Попередні версії Політики конфіденційності",
    title: "Конфіденційність та Xiaomi",
  },
  ur_IN: {
    version: "ورژن",
    privacy_history: "Xiaomi رازداری پالیسی کے پہلے کے ورژن",
    history_version: "رازداری پالیسی کے پہلے کے ورژن",
    title: "Xiaomi میں رازداری",
  },
  ur_PK: {
    version: "ورژن",
    privacy_history: "Xiaomi رازداری پالیسی کے پہلے کے ورژن",
    history_version: "رازداری پالیسی کے پہلے کے ورژن",
    title: "Xiaomi میں رازداری",
  },
  uz_UZ: {
    version: "Versiya",
    privacy_history: "Xiaomi Maxfiylik Siyosatining oldingi versiyalari",
    history_version: "Maxfiylik Siyosatining oldingi versiyalari",
    title: "Xiaomi‘dagi maxfiylik",
  },
  vi_VN: {
    version: "Phiên bản",
    privacy_history: "Phiên bản trước của Chính sách Riêng tư Xiaomi",
    history_version: "Phiên bản trước của Chính sách Riêng tư",
    title: "Chính sách Riêng tư Xiaomi",
  },
  zh_CN: {
    version: "版本号",
    privacy_history: "小米隐私政策历史版本",
    history_version: "隐私政策历史版本",
    title: "小米隐私",
  },
  zh_HK: {
    version: "版本號",
    privacy_history: "小米隱私政策歷史版本",
    history_version: "隱私政策歷史版本",
    title: "小米隱私",
  },
  zh_TW: {
    version: "版本號",
    privacy_history: "小米隱私政策歷史版本",
    history_version: "隱私政策歷史版本",
    title: "小米隱私",
  },
};

export default language;
